module.exports = __webpack_public_path__ + "media/metronic/_theme/media/files/jpg-beb3ddd8ba964b084c11758ba08e7afb.svg";